const themeNames = ['midday', 'dawn', 'morning', 'dusk', 'midnight'] as const;

export default themeNames;
